export default __webpack_public_path__ + "static/awkwardConsolation-50834cbdb3890f472ef50cfd02fa1b87.svg";